// Salary bounds applied to every salary input (Settings › Salary Info and the
// product eligibility gate).
export const MIN_SALARY = 2800;
export const MAX_SALARY = 100000;

export const isSalaryInRange = (value) => {
  const numeric = Number(value);
  return value !== "" && value != null && !Number.isNaN(numeric)
    && numeric >= MIN_SALARY && numeric <= MAX_SALARY;
};
